import { makeStyles } from 'tss-react/mui';

import { inputClasses } from '@mui/material';

import { MOBILE_BREAK_POINT } from 'app/constants';

export default makeStyles<void, 'placeholder'>({ name: 'SearchInput', uniqId: '6ZHlzx' })((theme, _, classes) => ({
    root: {
        width: '100%',
        boxSizing: 'border-box'
    },
    autocomplete: {
        borderRadius: 100,
        border: '1px solid transparent',
        background: 'rgba(35, 35, 35, 0.50)',
        padding: '8px 24px',
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            padding: '4px 16px'
        }
    },
    input: {
        width: '100%',
        boxSizing: 'border-box',
        color: '#fff',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        padding: '14px 24px',
        zIndex: 1,
        flex: 1,
        borderRadius: 100,
        border: '2px solid transparent',
        background: 'rgba(35, 35, 35, 0.50)',
        backdropFilter: 'blur(16px)',
        transition: 'border-color 0.2s',
        [`input`]: {
            caretColor: '#fff',
            padding: 0,
            height: 32
        },
        ['&:hover']: {
            borderColor: '#FF8B61',
            [`.${classes.placeholder}`]: {
                color: '#fff'
            }
        },
        [`&.${inputClasses.focused}`]: {
            borderColor: '#FF8B61',
            [`.${classes.placeholder}`]: {
                opacity: 0
            }
        },
        [theme.breakpoints.down(MOBILE_BREAK_POINT)]: {
            fontSize: 14,
            fontWeight: 500,
            lineHeight: '150%',
            padding: '6px 24px'
        }
    },
    list: {
        borderRadius: 24,
        border: '1px solid rgba(255, 255, 255, 0.05)',
        background: 'rgba(23, 22, 27, 0.75)',
        backdropFilter: 'blur(16px)',
        boxShadow: 'none',
        padding: '4px 8px'
    },
    option: {
        padding: 8,
        borderRadius: 8,
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '20px',
        color: '#FFF',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.05)'
        }
    },
    placeholder: {
        lineHeight: 'normal',
        maxWidth: '100%',
        zIndex: 0,
        userSelect: 'none',
        transition: 'color 0.2s, opacity 0.2s',
        position: 'absolute',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'nowrap',
        gap: 8,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: 'rgba(255, 255, 255, 0.5)'
    },
    ellipsis: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    matched: {
        color: 'rgba(255, 255, 255, 0.8)'
    },
    highlight: {
        color: '#fff',
        fontWeight: 700
    }
}));
